const A = (L) => L / 16, R = (L) => `${A(L)}rem`;
var E = /* @__PURE__ */ ((L) => (L[L.SMALL = 320] = "SMALL", L[L.MEDIUM = 768] = "MEDIUM", L[L.LARGE = 1024] = "LARGE", L[L.X_LARGE = 1440] = "X_LARGE", L[L.XX_LARGE = 1672] = "XX_LARGE", L))(E || {});
export {
  E as Breakpoints,
  R as pxToRem,
  A as remCalc
};
